import { createPortal } from "react-dom";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import ReceiptPrintPage from "../../../pages/ReceiptPrintPage";
import { getAutoPrint } from '../../../utils/printerSettings';
import { electronPrint, isElectron } from '../../../services/electronPrint.service';

export default function ReceiptPrintPopup({ isOpen, isCopy = false, isInvoice = false, onPrintComplete }) {
  const billData = useSelector((state) => state.bill.data);
  const paymentResponse = useSelector((state) => state.bill.paymentResponse);
  const pos = useSelector((state) => state.pos);

  useEffect(() => {
    if (!isOpen) return;

    const printTimer = setTimeout(async () => {
      if (isElectron()) {
        await electronPrint('receipt', { billData, paymentResponse, pos, isCopy, isInvoice });
        if (onPrintComplete) setTimeout(() => onPrintComplete(), 200);
        return;
      }
      if (getAutoPrint()) {
        window.print();
        if (onPrintComplete) {
          setTimeout(() => onPrintComplete(), 500);
        }
      }
    }, 500);

    return () => clearTimeout(printTimer);
  }, [isOpen, onPrintComplete, billData, paymentResponse, pos, isCopy, isInvoice]);

  if (!isOpen) return null;

  return (
    <>
      {createPortal(
        <div className="section-to-print-receipt-page pb-10">
          <ReceiptPrintPage />
        </div>,
        document.body
      )}
    </>
  );
}
